import invariant from 'invariant';
import { NativeEventEmitter, Platform } from 'react-native';
const nativeEmitterSubscriptionKey = '@@nativeEmitterSubscription@@';
/**
 * @deprecated Deprecated in favor of `EventEmitter`.
 */ export class LegacyEventEmitter {
    _listenerCount = 0;
    // @ts-expect-error
    _nativeModule;
    // @ts-expect-error
    _eventEmitter;
    constructor(nativeModule){
        // If the native module is a new module, just return it back as it's already an event emitter.
        // This is for backwards compatibility until we stop using this legacy class in other packages.
        if (nativeModule.__expo_module_name__) {
            // @ts-expect-error
            return nativeModule;
        }
        this._nativeModule = nativeModule;
        this._eventEmitter = new NativeEventEmitter(nativeModule);
    }
    addListener(eventName, listener) {
        if (!this._listenerCount && Platform.OS !== 'ios' && this._nativeModule.startObserving) {
            this._nativeModule.startObserving();
        }
        this._listenerCount++;
        // The cast keeps this compiling under both the legacy and the strict
        // react-native API: the strict EventEmitter wants `(...args: readonly
        // Object[]) => unknown` listeners. This EventEmitter is deprecated anyway.
        const nativeEmitterSubscription = this._eventEmitter.addListener(eventName, listener);
        const subscription = {
            [nativeEmitterSubscriptionKey]: nativeEmitterSubscription,
            remove: ()=>{
                this.removeSubscription(subscription);
            }
        };
        return subscription;
    }
    removeAllListeners(eventName) {
        // @ts-ignore: the EventEmitter interface has been changed in react-native@0.64.0
        const removedListenerCount = this._eventEmitter.listenerCount ? this._eventEmitter.listenerCount(eventName) : this._eventEmitter.listeners(eventName).length;
        this._eventEmitter.removeAllListeners(eventName);
        this._listenerCount -= removedListenerCount;
        invariant(this._listenerCount >= 0, `EventEmitter must have a non-negative number of listeners`);
        if (!this._listenerCount && Platform.OS !== 'ios' && this._nativeModule.stopObserving) {
            this._nativeModule.stopObserving();
        }
    }
    removeSubscription(subscription) {
        const state = subscription;
        const nativeEmitterSubscription = state[nativeEmitterSubscriptionKey];
        if (!nativeEmitterSubscription) {
            return;
        }
        if ('remove' in nativeEmitterSubscription) {
            nativeEmitterSubscription.remove?.();
        }
        this._listenerCount--;
        // Ensure that the emitter's internal state remains correct even if `removeSubscription` is
        // called again with the same subscription
        delete state[nativeEmitterSubscriptionKey];
        // Release closed-over references to the emitter
        subscription.remove = ()=>{};
        if (!this._listenerCount && Platform.OS !== 'ios' && this._nativeModule.stopObserving) {
            this._nativeModule.stopObserving();
        }
    }
    emit(eventName, ...params) {
        this._eventEmitter.emit(eventName, ...params);
    }
}

//# sourceMappingURL=LegacyEventEmitter.js.map
